import { usePageNumberFromUrl, usePerPageValueFromUrl, useSortValueFromUrl } from 'idsk-react-components';
import { SortDirectionEnum } from 'sprava-aktov-eu-frontend-ts-axios';
import NavrhAktuEuFilter from '../../../model/NavrhAktuEuFilter';
import { defaultSort, sortValues } from '../../../constants/NavrhAktEuSortConstants';
import { ClientStatus } from '../../../model/ClientStatus';
import { useClientFetch } from '../../../context/ClientStatusContext';
import NavrhAktuEuListPage from '../../../model/NavrhAktuEuListPage';
import { defaultPerPageValue, perPageDataArray } from '../../../constants/PaginationPerPageConstants';
import { fetchAktEuListPage } from '../../../client/external/aktEuListClient';

interface ReturnType {
  aktEuPage?: NavrhAktuEuListPage | null;
  requestStatus: ClientStatus;
}

const getSort = (sortValue): string => {
  if (!sortValues.includes(sortValue)) {
    return defaultSort;
  }
  return sortValue;
};

export default (filter: NavrhAktuEuFilter): ReturnType => {
  const { page } = usePageNumberFromUrl('page');
  const { perPageValue } = usePerPageValueFromUrl('perPage', perPageDataArray, defaultPerPageValue);
  const { sort } = useSortValueFromUrl();
  const {
    data: aktEuPage,
    status: requestStatus,
  } = useClientFetch(
    () => fetchAktEuListPage(
      filter,
      page,
      perPageValue,
      getSort(sort[0]),
      sort[1] === 'asc' ? SortDirectionEnum.Asc : SortDirectionEnum.Desc,
    ),
    [JSON.stringify(filter), page, perPageValue, sort[0], sort[1]],
  );
  return {
    aktEuPage,
    requestStatus,
  };
};
